module.exports = __webpack_public_path__ + "static/media/icon_channel_discovery.0e184f21.svg";